export enum ScreenType {
  Home = '',
  Select = 'products',
  Order = 'order',
  Details = 'order-details',
  Present = 'presents',
}
